import { setupNextraPage } from 'nextra/setup-page'
import __nextra_layout from 'nextra-theme-docs'
import __nextra_themeConfig from '/Users/changcheng/Sites/localhost/funda-ui-doc-dev/theme.config.tsx'

import 'nextra-theme-docs/style.css'
/*@jsxRuntime automatic @jsxImportSource react*/
// <input .../>, true, <input .../>
import {useMDXComponents as _provideComponents} from "nextra/mdx";
import InitMenu from '../../src/components/InitMenu';
import React, {useState, useEffect, useRef} from "react";
import Checkbox from 'funda-ui/Checkbox';
export const Demo1 = () => {
  function handleChange(e, val, element) {
    // <input .../>, true, <input .../>
    console.log(e.target, val, element);
  }
  return <>


            <Checkbox name="string" label="Label" value="ok" onChange={handleChange} />
            
            <Checkbox name="string" label="Label" value="ok" checked />
            

            <Checkbox name="string" label="Label" value="ok" disabled />

            
            <Checkbox name="string" label="Indeterminate" value="ok" indeterminate />


        </>;
};
export const Demo2 = () => {
  const _components = Object.assign({
    a: "a"
  }, _provideComponents());
  const [checked, setChecked] = useState(null);
  function handleClick1(e) {
    e.preventDefault();
    setChecked(true);
  }
  function handleClick2(e) {
    e.preventDefault();
    setChecked(false);
  }
  return <>

            <_components.a href="#" onClick={handleClick1}>checked</_components.a>
              |  
            <_components.a href="#" onClick={handleClick2}>unchecked</_components.a>
            
            <Checkbox name="string" label="Label" value="ok" checked={checked} />


        </>;
};
export const myCheckboxesData = [{
  "item_code": "01",
  "item_name": "Title 1"
}, {
  "item_code": "02",
  "item_name": "Title 2"
}, {
  "item_code": "03",
  "item_name": "Title 3"
}, {
  "item_code": "04",
  "item_name": "Title 4"
}];
export const Demo3 = () => {
  const _components = Object.assign({
    div: "div",
    small: "small"
  }, _provideComponents());
  const defaultValue = 'Title 1,Title 3';
  const [valSelected, setValSelected] = useState([]);
  useEffect(() => {
    setValSelected(defaultValue.split(',').filter(v => v !== ''));
  }, []);
  return <>

            {myCheckboxesData ? myCheckboxesData.map(item => {
    return <_components.div key={item.item_code} className="mb-3 position-relative d-inline-block pe-3">
                    <Checkbox wrapperClassName="" label={item.item_name} value={item.item_name} onChange={(e, val) => {
      setValSelected(prevState => {
        const newData = JSON.parse(JSON.stringify(prevState));
        const index = newData.findIndex(item => item == e.target.value);
        if (index !== -1) newData.splice(index, 1);
        return val ? Array.from(new Set([e.target.value, ...newData])) : newData;
      });
    }} checked={valSelected.includes(item.item_name)} /></_components.div>;
  }) : null}

            <_components.small className="border">{valSelected.join(',')}</_components.small>


        </>;
};
export const Demo4 = () => {
  const _components = Object.assign({
    a: "a"
  }, _provideComponents());
  const conRef = useRef(null);
  const [userContent, setUserContent] = useState(true);
  return <>
      
            <_components.a href="#" onClick={e => {
    e.preventDefault();
    if (conRef.current) conRef.current.clear(() => {
      setUserContent(false);
    });
  }}>Reset</_components.a>
              |  
            <_components.a href="#" onClick={e => {
    e.preventDefault();
    if (conRef.current) conRef.current.set(true, () => {
      setUserContent(true);
    });
  }}>Change value</_components.a>
  

            <Checkbox label="Label" contentRef={conRef} name="string" value="ok" checked={userContent} />


        </>;
};
export const __toc = [{
  depth: 2,
  value: "General",
  id: "general"
}, {
  depth: 2,
  value: "No spacing",
  id: "no-spacing"
}, {
  depth: 2,
  value: "Asynchronous Usage",
  id: "asynchronous-usage"
}, {
  depth: 2,
  value: "Simulate multiple selection",
  id: "simulate-multiple-selection"
}, {
  depth: 2,
  value: "Use the exposed method to assign and empty",
  id: "use-the-exposed-method-to-assign-and-empty"
}, {
  depth: 2,
  value: "❤️ API",
  id: "️-api"
}, {
  depth: 3,
  value: "Checkbox",
  id: "checkbox"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h2: "h2",
    details: "details",
    summary: "summary",
    pre: "pre",
    code: "code",
    span: "span",
    p: "p",
    h3: "h3",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    strong: "strong",
    em: "em"
  }, _provideComponents(), props.components);
  return <><InitMenu />{"\n"}<_components.h1>{"Checkbox"}</_components.h1>{"\n"}{"\n"}<_components.h2 id="general">{"General"}</_components.h2>{"\n"}<br />{"\n"}{"\n"}<Demo1 />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Checkbox "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Checkbox'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"handleChange"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ChangeEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"HTMLInputElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"> "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"|"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"boolean"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" element"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".target"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" element); "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// <input .../>, true, <input .../>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"string\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Label'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"ok\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{handleChange}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"string\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Label'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"ok\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"checked"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"string\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Label'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"ok\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"disabled"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"string\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Indeterminate'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"ok\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"indeterminate"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    );"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="no-spacing">{"No spacing"}</_components.h2>{"\n"}<br />{"\n"}<Checkbox wrapperClassName="position-relative" name="string" label="Label" value="ok" />{"\n"}<Checkbox wrapperClassName="position-relative" name="string" label="Label" value="ok" checked />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Checkbox "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Checkbox'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ..."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"position-relative\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ..."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"             <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ..."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ..."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    );"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="asynchronous-usage">{"Asynchronous Usage"}</_components.h2>{"\n"}<br />{"\n"}{"\n"}<Demo2 />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Checkbox "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Checkbox'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setChecked"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"   "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"handleClick1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setChecked"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"handleClick2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setChecked"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }  "}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"href"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{handleClick1}>checked</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            &nbsp;&nbsp;|&nbsp;&nbsp;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"href"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{handleClick2}>unchecked</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"string\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Label'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"ok\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{checked}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    )"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="simulate-multiple-selection">{"Simulate multiple selection"}</_components.h2>{"\n"}<br />{"\n"}{"\n"}{"\n"}<Demo3 />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useEffect } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Checkbox "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Checkbox'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"myCheckboxesData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_code\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"01\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 1\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_code\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"02\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 2\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_code\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"03\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 3\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_code\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"04\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 4\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Title 1,Title 3'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"valSelected"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setValSelected"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]>([]);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"   "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useEffect"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(() "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setValSelected"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"defaultValue"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".split"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"','"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".filter"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(v "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" v "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"));"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {myCheckboxesData "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"myCheckboxesData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"key"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".item_code} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mb-3 position-relative d-inline-block pe-3\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".item_name}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".item_name}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ChangeEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"HTMLInputElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"> "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"|"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"boolean"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" element"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setValSelected"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((prevState) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"newData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"JSON"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".parse"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"JSON"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".stringify"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(prevState));"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"index"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"newData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".findIndex"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"|"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"number"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"target"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (index "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"newData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".splice"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(index"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (val) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Array"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"new"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"Set"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"target"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"..."}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"newData])) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" newData;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            });"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"valSelected"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".includes"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".item_name)}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    /></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"small"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"border\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"valSelected"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".join"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"','"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")}</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"small"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    )"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="use-the-exposed-method-to-assign-and-empty">{"Use the exposed method to assign and empty"}</_components.h2>{"\n"}<_components.p>{"Lets you callback the handle exposed as attribute "}<_components.code>{"contentRef"}</_components.code>{"."}</_components.p>{"\n"}<br />{"\n"}{"\n"}<Demo4 />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useRef } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'react'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// bootstrap components"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ModalDialog "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/ModalDialog'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Checkbox "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Checkbox'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"conRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"userContent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setUserContent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"boolean"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"href"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ChangeEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"HTMLInputElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"conRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"conRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"current"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".clear"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(() "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setUserContent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                });"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }}>Reset</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            &nbsp;&nbsp;|&nbsp;&nbsp;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"href"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ChangeEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"HTMLInputElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"conRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"conRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"current"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".set"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setUserContent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                });"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }}>Change value</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"       "}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"contentRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{conRef}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"label"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Label'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"string\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"ok\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{userContent}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    )"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="️-api">{"❤️ API"}</_components.h2>{"\n"}<_components.h3 id="checkbox">{"Checkbox"}</_components.h3>{"\n"}<_components.pre data-language="js" data-theme="default"><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Checkbox "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Checkbox'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"ref"}</_components.code></_components.td><_components.td>{"React.ForwardedRef"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"It is the return element of this component."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"contentRef"}</_components.code></_components.td><_components.td>{"React.ForwardedRef"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"It exposes the following methods:  "}<br />{" "}<ol><li><_components.code>{"contentRef.current.control()"}</_components.code></li><li><_components.code>{"contentRef.current.getLatestVal()"}</_components.code></li><li><_components.code>{"contentRef.current.clear(() => { console.log('callback') })"}</_components.code></li><li><_components.code>{"contentRef.current.set(false, () => { console.log('callback') })"}</_components.code></li></ol>{" "}<blockquote>{"DO NOT USE it in the "}<_components.code>{"onChange"}</_components.code>{" of this component, otherwise it will cause infinite rendering"}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"wrapperClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td><_components.code>{"mb-3 position-relative"}</_components.code></_components.td><_components.td>{"The class name of the control wrapper."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"controlClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td><_components.code>{"form-check-input"}</_components.code></_components.td><_components.td>{"The class name of the control."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"itemSelectedClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td><_components.code>{"item-selected"}</_components.code></_components.td><_components.td>{"The class name of the item selected."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"checked"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Is it selected."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"indeterminate"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Set a checkbox to indeterminate state."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"value"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Set a default value for this control. If unchecked, it will pass an empty value"}</_components.td><_components.td>{"✅"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"label"}</_components.code></_components.td><_components.td>{"string | ReactNode"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"It is used to specify a label for an element of a form."}<blockquote>{"Support html tags"}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"name"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Name is not deprecated when used with form fields."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"disabled"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Whether it is disabled"}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"required"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"When present, it specifies that a field must be filled out before submitting the form."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onChange"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Call a function when the value of an HTML element is changed.  It returns two callback values. "}<br />{" "}<ol><li>{"The first is the Control Event ("}<_components.strong>{"Event"}</_components.strong>{")"}</li><li>{"The second is the current value ("}<_components.strong>{"Boolean"}</_components.strong>{") "}</li><li>{"The last is the current control ("}<_components.strong>{"HTML Element"}</_components.strong>{")"}</li></ol>{" "}<blockquote>{"If the "}<_components.em>{"first parameter"}</_components.em>{" is "}<_components.code>{"null"}</_components.code>{", it means that the exposure method of "}<_components.code>{"contentRef"}</_components.code>{" is used to modify the current value."}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onBlur"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Call a function when a user leaves a form field. It returns only one callback value which is the Control Event ("}<_components.strong>{"Event"}</_components.strong>{")"}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onFocus"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Call a function when an form field gets focus. It returns only one callback value which is the Control Event ("}<_components.strong>{"Event"}</_components.strong>{")"}</_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.p>{"It accepts all props which this control support. Such as "}<_components.code>{"style"}</_components.code>{", "}<_components.code>{"data-*"}</_components.code>{", "}<_components.code>{"tabIndex"}</_components.code>{", "}<_components.code>{"id"}</_components.code>{", and so on."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/Forms/Checkbox.html.mdx","route":"/Forms/Checkbox.html","timestamp":1768462508000,"pageMap":[{"kind":"Folder","name":"Applications","route":"/Applications","children":[{"kind":"Meta","data":{"collecting-data.html":"Collecting Data"}},{"kind":"MdxPage","name":"collecting-data.html","route":"/Applications/collecting-data.html"}]},{"kind":"Folder","name":"Forms","route":"/Forms","children":[{"kind":"MdxPage","name":"CascadingSelect.html","route":"/Forms/CascadingSelect.html"},{"kind":"MdxPage","name":"CascadingSelectE2E.html","route":"/Forms/CascadingSelectE2E.html"},{"kind":"MdxPage","name":"Checkbox.html","route":"/Forms/Checkbox.html"},{"kind":"MdxPage","name":"ColorPicker.html","route":"/Forms/ColorPicker.html"},{"kind":"MdxPage","name":"Date.html","route":"/Forms/Date.html"},{"kind":"MdxPage","name":"DynamicFields.html","route":"/Forms/DynamicFields.html"},{"kind":"MdxPage","name":"File.html","route":"/Forms/File.html"},{"kind":"MdxPage","name":"Input.html","route":"/Forms/Input.html"},{"kind":"MdxPage","name":"LiveSearch.html","route":"/Forms/LiveSearch.html"},{"kind":"MdxPage","name":"MultipleCheckboxes.html","route":"/Forms/MultipleCheckboxes.html"},{"kind":"MdxPage","name":"MultipleSelect.html","route":"/Forms/MultipleSelect.html"},{"kind":"MdxPage","name":"NativeSelect.html","route":"/Forms/NativeSelect.html"},{"kind":"MdxPage","name":"NumberInput.html","route":"/Forms/NumberInput.html"},{"kind":"MdxPage","name":"Radio.html","route":"/Forms/Radio.html"},{"kind":"MdxPage","name":"RangeSlider.html","route":"/Forms/RangeSlider.html"},{"kind":"MdxPage","name":"SearchBar.html","route":"/Forms/SearchBar.html"},{"kind":"MdxPage","name":"Select.html","route":"/Forms/Select.html"},{"kind":"MdxPage","name":"Switch.html","route":"/Forms/Switch.html"},{"kind":"MdxPage","name":"TagInput.html","route":"/Forms/TagInput.html"},{"kind":"MdxPage","name":"Textarea.html","route":"/Forms/Textarea.html"},{"kind":"Meta","data":{"CascadingSelect.html":"Cascading Select","CascadingSelectE2E.html":"Cascading Select End-to-end 🔥","Checkbox.html":"Checkbox","ColorPicker.html":"Color Picker","Date.html":"Date 🔥","DynamicFields.html":"Dynamic Fields 🔥","File.html":"File","Input.html":"Input 🤖","LiveSearch.html":"Live Search","MultipleCheckboxes.html":"Multiple Checkboxes","MultipleSelect.html":"Multiple Select 🔥","NativeSelect.html":"Native Select","NumberInput.html":"Number Input","Radio.html":"Radio","RangeSlider.html":"Range Slider","SearchBar.html":"Search Bar","Select.html":"Select 🔥","Switch.html":"Switch","TagInput.html":"Tag Input","Textarea.html":"Textarea 🤖"}}]},{"kind":"Folder","name":"Getting-Started","route":"/Getting-Started","children":[{"kind":"MdxPage","name":"Installation.html","route":"/Getting-Started/Installation.html"},{"kind":"MdxPage","name":"Usage.html","route":"/Getting-Started/Usage.html"},{"kind":"Meta","data":{"Installation.html":"Installation","Usage.html":"Usage"}}]},{"kind":"Folder","name":"Hooks","route":"/Hooks","children":[{"kind":"Meta","data":{"useKeyPress.html":"useKeyPress","usePageVisibility.html":"usePageVisibility","useThrottle.html":"useThrottle","useDebounce.html":"useDebounce","useComId.html":"useComId","useInterval.html":"useInterval","useWindowScroll.html":"useWindowScroll","useAutosizeTextArea.html":"useAutosizeTextArea","useClickOutside.html":"useClickOutside","useDraggable.html":"useDraggable","useBoundedDrag.html":"useBoundedDrag","useStreamController.html":"useStreamController","useHistoryTracker.html":"useHistoryTracker","useSSE.html":"useSSE"}},{"kind":"MdxPage","name":"useAutosizeTextArea.html","route":"/Hooks/useAutosizeTextArea.html"},{"kind":"MdxPage","name":"useBoundedDrag.html","route":"/Hooks/useBoundedDrag.html"},{"kind":"MdxPage","name":"useClickOutside.html","route":"/Hooks/useClickOutside.html"},{"kind":"MdxPage","name":"useComId.html","route":"/Hooks/useComId.html"},{"kind":"MdxPage","name":"useDebounce.html","route":"/Hooks/useDebounce.html"},{"kind":"MdxPage","name":"useDraggable.html","route":"/Hooks/useDraggable.html"},{"kind":"MdxPage","name":"useHistoryTracker.html","route":"/Hooks/useHistoryTracker.html"},{"kind":"MdxPage","name":"useInterval.html","route":"/Hooks/useInterval.html"},{"kind":"MdxPage","name":"useKeyPress.html","route":"/Hooks/useKeyPress.html"},{"kind":"MdxPage","name":"usePageVisibility.html","route":"/Hooks/usePageVisibility.html"},{"kind":"MdxPage","name":"useSSE.html","route":"/Hooks/useSSE.html"},{"kind":"MdxPage","name":"useStreamController.html","route":"/Hooks/useStreamController.html"},{"kind":"MdxPage","name":"useThrottle.html","route":"/Hooks/useThrottle.html"},{"kind":"MdxPage","name":"useWindowScroll.html","route":"/Hooks/useWindowScroll.html"}]},{"kind":"Folder","name":"Interaction","route":"/Interaction","children":[{"kind":"MdxPage","name":"DragDropList.html","route":"/Interaction/DragDropList.html"},{"kind":"MdxPage","name":"HorizontalScrollContent.html","route":"/Interaction/HorizontalScrollContent.html"},{"kind":"MdxPage","name":"ModeSwitch.html","route":"/Interaction/ModeSwitch.html"},{"kind":"MdxPage","name":"Refresher.html","route":"/Interaction/Refresher.html"},{"kind":"MdxPage","name":"ScrollReveal.html","route":"/Interaction/ScrollReveal.html"},{"kind":"MdxPage","name":"Scrollbar.html","route":"/Interaction/Scrollbar.html"},{"kind":"Meta","data":{"DragDropList.html":"DragDrop List 🔥","HorizontalScrollContent.html":"Horizontal Scroll Content","ModeSwitch.html":"Mode Switch","Refresher.html":"Refresher","Scrollbar.html":"Custom Scrollbar","ScrollReveal.html":"Scroll Reveal"}}]},{"kind":"Folder","name":"Layouts","route":"/Layouts","children":[{"kind":"MdxPage","name":"MasonryLayout.html","route":"/Layouts/MasonryLayout.html"},{"kind":"MdxPage","name":"RootPortal.html","route":"/Layouts/RootPortal.html"},{"kind":"MdxPage","name":"SplitterPanel.html","route":"/Layouts/SplitterPanel.html"},{"kind":"Meta","data":{"MasonryLayout.html":"Masonry Layout","RootPortal.html":"Root Portal","SplitterPanel.html":"Splitter Panel"}}]},{"kind":"Folder","name":"Navigation","route":"/Navigation","children":[{"kind":"MdxPage","name":"DropdownMenu.html","route":"/Navigation/DropdownMenu.html"},{"kind":"MdxPage","name":"MultilevelDropdownMenu.html","route":"/Navigation/MultilevelDropdownMenu.html"},{"kind":"Meta","data":{"DropdownMenu.html":"Dropdown Menu","MultilevelDropdownMenu.html":"Multilevel Dropdown Menu"}}]},{"kind":"Folder","name":"Web-Elements","route":"/Web-Elements","children":[{"kind":"MdxPage","name":"Accordion.html","route":"/Web-Elements/Accordion.html"},{"kind":"MdxPage","name":"BackToTop.html","route":"/Web-Elements/BackToTop.html"},{"kind":"MdxPage","name":"Chatbox.html","route":"/Web-Elements/Chatbox.html"},{"kind":"MdxPage","name":"DigitalClock.html","route":"/Web-Elements/DigitalClock.html"},{"kind":"MdxPage","name":"EventCalendar.html","route":"/Web-Elements/EventCalendar.html"},{"kind":"MdxPage","name":"EventCalendarTimeline.html","route":"/Web-Elements/EventCalendarTimeline.html"},{"kind":"MdxPage","name":"ModalDialog.html","route":"/Web-Elements/ModalDialog.html"},{"kind":"MdxPage","name":"Pagination.html","route":"/Web-Elements/Pagination.html"},{"kind":"MdxPage","name":"Popover.html","route":"/Web-Elements/Popover.html"},{"kind":"MdxPage","name":"ShowMoreLess.html","route":"/Web-Elements/ShowMoreLess.html"},{"kind":"MdxPage","name":"Stepper.html","route":"/Web-Elements/Stepper.html"},{"kind":"MdxPage","name":"Table.html","route":"/Web-Elements/Table.html"},{"kind":"MdxPage","name":"Tabs.html","route":"/Web-Elements/Tabs.html"},{"kind":"MdxPage","name":"Toast.html","route":"/Web-Elements/Toast.html"},{"kind":"MdxPage","name":"Tooltip.html","route":"/Web-Elements/Tooltip.html"},{"kind":"MdxPage","name":"Tree.html","route":"/Web-Elements/Tree.html"},{"kind":"Meta","data":{"Accordion.html":"Accordion","BackToTop.html":"Back To Top","Chatbox.html":"Chatbox 🔥🤖","DigitalClock.html":"Digital Clock","EventCalendar.html":"Event Calendar 🔥","EventCalendarTimeline.html":"Event Calendar Timeline 🔥","ModalDialog.html":"Modal Dialog 🔥","Popover.html":"Popover 🔥","Pagination.html":"Pagination","ShowMoreLess.html":"Show More Less","Stepper.html":"Stepper","Table.html":"Table 🔥","Tabs.html":"Tabs","Toast.html":"Toast","Tooltip.html":"Tooltip","Tree.html":"Tree 🔥"}}]},{"kind":"Meta","data":{"index":"Introduction","Getting-Started":"","---":{"type":"separator","title":"Components"},"Applications":"","Forms":"","Web-Elements":"","Navigation":"","Interaction":"","Layouts":"","contact":{"title":"Source ↗","type":"page","href":"https://github.com/xizon/funda-ui","newWindow":true}}},{"kind":"MdxPage","name":"index","route":"/"}],"flexsearch":{"codeblocks":true},"title":"Checkbox",headings:__toc},
  pageNextRoute: "/Forms/Checkbox.html",
  nextraLayout: __nextra_layout,themeConfig: __nextra_themeConfig
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)